import { render, staticRenderFns } from "./ChooseBranch.vue?vue&type=template&id=158b4e53&scoped=true&"
import script from "./ChooseBranch.vue?vue&type=script&lang=js&"
export * from "./ChooseBranch.vue?vue&type=script&lang=js&"
import style0 from "./ChooseBranch.vue?vue&type=style&index=0&id=158b4e53&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158b4e53",
  null
  
)

export default component.exports